import base from '../dr-base'
import drTabs from './dr-tabs.vue'

const schema = {
  $Type: 'dr-tabs',
  name: 'Tabs',
  group: 'Container widgets',
  icon: 'table',
  ...base,
  properties: {
    ...base.properties,
    Tabs: {
      type: 'array',
      items: {
        type: 'object'
      },
      default: [
        {
          $ID: '0.9933601282051245',
          $Type: 'dr-tab',
          Text: 'Tab',
          Widgets: []
        },
        {
          $ID: '0.9341942349242076',
          $Type: 'dr-tab',
          Text: 'Tab',
          Widgets: []
        },
        {
          $ID: '0.3303405372329926',
          $Type: 'dr-tab',
          Text: 'Tab',
          Widgets: []
        }
      ]
    },
    Widgets: {
      type: 'array'
    },
    CurrentTab: {
      name: 'vuetifyWidgets.dr-tabs.сurrentTab',
      type: 'string',
      hint: 'vuetifyWidgets.dr-tabs.hint'
    },
    TabPosition: {
      name: 'vuetifyWidgets.dr-tabs.tabPosition',
      type: 'string',
      enum: [
        {
          value: 'left',
          text: 'vuetifyWidgets.dr-tabs.left'
        } ,{
          value: 'right',
          text: 'vuetifyWidgets.dr-tabs.right'
        },{
          value: 'centered',
          text: 'vuetifyWidgets.dr-tabs.centered'
        },{
          value: 'vertical',
          text: 'vuetifyWidgets.dr-tabs.vertical'
        }
      ]
    },
    ClassTabs: {
      name: 'vuetifyWidgets.dr-tabs.classTabs',
      type: 'string',
      default: ''
    }
  }
}

export default {
  schema,
  component: drTabs
}
